import { render, staticRenderFns } from "./sport_competition_result_submitted.vue?vue&type=template&id=edf38e40&scoped=true&"
import script from "./sport_competition_result_submitted.vue?vue&type=script&lang=js&"
export * from "./sport_competition_result_submitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf38e40",
  null
  
)

export default component.exports